import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, Save, Rabbit } from "lucide-react";

export default function LostGiraffeAdmin() {
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState(false);
  const [postId, setPostId] = useState("");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data || [])).catch(() => {});
    api.get("/lost-giraffe").then((r) => {
      const d = r.data || {};
      setActive(!!d.active);
      setPostId(d.post_id || "");
      setMessage(d.message || "");
    }).catch(() => {});
  }, []);

  const save = async () => {
    if (active && !postId) return toast.error("Scegli l'articolo dove nascondere la giraffina");
    setSaving(true);
    try {
      await api.put("/lost-giraffe", { active, post_id: postId || null, message: message.trim() });
      toast.success("Impostazioni salvate");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore");
    } finally {
      setSaving(false);
    }
  };

  const selectedSlug = posts.find((p) => p.id === postId)?.slug;

  return (
    <div className="relative z-10 min-h-screen bg-[#F9F8F6]">
      <div className="border-b border-[#E7E5E4] bg-[#F2F0EB]">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/admin" className="inline-flex items-center gap-2 label-ui text-[#57534E] hover:text-[#9F583F]"><ArrowLeft size={15} /> Torna</Link>
          {active && selectedSlug && (
            <Link to={`/articolo/${selectedSlug}`} target="_blank" className="inline-flex items-center gap-2 label-ui text-[#57534E] hover:text-[#9F583F]">Vedi l'articolo</Link>
          )}
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-12">
        <p className="label-ui text-[#9F583F] mb-2">La Giraffa Perduta</p>
        <h1 className="font-display text-4xl tracking-tight text-[#1C1917] mb-3">Caccia alla giraffina</h1>
        <p className="font-body text-[#57534E] mb-10 max-w-2xl">
          Nascondi una piccola giraffa in un articolo. Chi la trova può cliccarci sopra per rimetterla nel cassetto e riceve un ringraziamento speciale.
        </p>

        <div className="border border-[#E7E5E4] bg-[#F2F0EB] p-6 space-y-6">
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
              data-testid="lost-active-toggle"
              className="w-5 h-5 accent-[#9F583F]"
            />
            <span className="inline-flex items-center gap-2 font-display text-lg text-[#1C1917]">
              <Rabbit size={18} className="text-[#9F583F]" /> Caccia attiva
            </span>
          </label>

          <div>
            <label className="label-ui text-[#57534E] block mb-2">Articolo dove si nasconde</label>
            <select
              value={postId}
              onChange={(e) => setPostId(e.target.value)}
              data-testid="lost-post-select"
              className="w-full font-ui text-sm border border-[#E7E5E4] bg-white px-3 py-2.5 focus:outline-none focus:border-[#9F583F]"
            >
              <option value="">— Scegli un articolo —</option>
              {posts.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
            </select>
          </div>

          <div>
            <label className="label-ui text-[#57534E] block mb-2">Messaggio di ringraziamento</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={3}
              maxLength={500}
              placeholder="Es. Grazie di cuore! Mi avevi smarrita e tu mi hai riportata a casa 🦒💛"
              data-testid="lost-message-input"
              className="w-full font-ui text-sm border border-[#E7E5E4] bg-white px-3 py-2 focus:outline-none focus:border-[#9F583F]"
            />
            <p className="label-ui text-[#A8A29E] mt-2">Se lo lasci vuoto verrà usato un ringraziamento predefinito.</p>
          </div>

          <button
            onClick={save}
            disabled={saving}
            data-testid="lost-save"
            className="inline-flex items-center gap-2 bg-[#9F583F] text-white label-ui px-6 py-3 hover:bg-[#1C1917] transition-colors disabled:opacity-60"
          >
            <Save size={15} /> {saving ? "Salvataggio…" : "Salva"}
          </button>
        </div>
      </div>
    </div>
  );
}
